<div *ngIf="showAnimation"
	id="splashAnimation"
	class="vtr-home d-flex align-items-center justify-content-center">
	<fa-icon [icon]="['fal', 'circle-notch']"
		class="spinner"
		[spin]="true"
		role="img"
		aria-label="spinner">
	</fa-icon>
</div>
